import React from 'react';
import { DashboardNew } from 'screens/coach';
function DoctorTeleconnectScreen() {
  return <DashboardNew />;
}

export default DoctorTeleconnectScreen;
